import { Paper, Typography, Table, TableBody, TableRow, TableCell, Button } from '@material-ui/core';
import type { StyledComponentProps } from '@material-ui/core/styles';
import Spin from 'components/Spin';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { listNewzz, clickNewzz } from 'store/Orbita/Dashboard/actions';

import styles from '../../styles';

import type { DispatchProp } from 'react-redux';

interface IProps extends DispatchProp<any>, StyledComponentProps {
  listNewzz: any;
  isFetching: boolean;
}

class News extends Component<IProps, any> {
  constructor(props: any) {
    super(props);
    this.state = {};
  }

  clickNewzz = async (value: any) => {
    await this.props.dispatch(clickNewzz(value));
  };

  componentDidMount() {
    (async () => {
      try {
        await this.props.dispatch(listNewzz(10));
      } catch (error) {
        //toast.error('Ops, erro na listagem de News');
      }
    })();
  }

  render() {
    const { classes, listNewzz, isFetching } = this.props;
    return (
      <Paper square={false} elevation={0} classes={{ root: classes.paper }}>
        <div className={classes.smallCard}>
          {isFetching ? (
            <Spin />
          ) : (
            <div>
              <div className={classes.cardHead}>
                <Typography variant='h6'>Newzz</Typography>
              </div>
              <div className={classes.cardContent}>
                <div className={classes.tabContainer}>
                  <Table className={classes.table}>
                    <TableBody>
                      {listNewzz &&
                        Array.isArray(listNewzz.data) &&
                        listNewzz.data.map((item: any) => {
                          return (
                            <TableRow key={item.id}>
                              <TableCell onClick={() => this.clickNewzz(item.id)}>
                                {item.has_content ? (
                                  <Link to={`news/info/${item.id}`}>{item.title}</Link>
                                ) : (
                                  <a className={classes.linkNews} target='_blank' rel='noopener noreferrer' href={item.external_url}>
                                    {' '}
                                    {item.title}
                                  </a>
                                )}
                              </TableCell>
                              {<TableCell style={{ color: '#009358', fontWeight: 'bold' }}>{item.show_tag_new ? 'NOVO' : ''}</TableCell>}
                            </TableRow>
                          );
                        })}
                    </TableBody>
                  </Table>

                  <div className='m16'></div>
                  {listNewzz && !listNewzz.isFetching && (
                    <div style={{ width: '100%', padding: 12, textAlign: 'right' }}>
                      <Link to={'/producer/news'} style={{ color: '#222', textDecoration: 'none' }}>
                        <Button color='default'>Ver Mais</Button>
                      </Link>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </Paper>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    listNewzz: state.orbita.Dashboard.listNewzz,
    isFetching: state.orbita.Dashboard.listNewzz.isFetching,
  };
}
export default styles(connect(mapStateToProps)(News));
